// src/pages/Blog.js
import React, { useEffect, useState, useContext } from 'react';
import { getBlogPost } from '../utils/api';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { LanguageContext } from '../utils/LanguageContext';

const Blog = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const data = await getBlogPost();
        setPost(data);
      } catch (error) {
        console.error('Error fetching blog post:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, []);

  if (loading) return <p>Loading blog post...</p>;
  if (!post) return <p>Blog post not found.</p>;

  const localizedContent =
    post.fields.languageTranslation?.[language] ||
    post.fields.languageTranslation?.en;

  return (
    <div className="blog-container" style={{ marginLeft: '50px' }}>
      <h2>{localizedContent.title}</h2>
      <p>{localizedContent.shortDescription}</p>

      {post.fields.featuredImage?.fields?.file?.url && (
        <img
          src={`https:${post.fields.featuredImage.fields.file.url}`}
          alt={post.fields.featuredImage.fields.title}
          style={{ width: '100%', maxWidth: '500px', marginBottom: '20px' }}
        />
      )}

      {/* ✅ Render Rich Text Content based on selected language */}
      <div>{documentToReactComponents(localizedContent.content)}</div>
    </div>
  );
};

export default Blog;
